interface IProductHeader {
  name: string;
  description?: string;
  count: number;
  search?: boolean;
}
const getSearchStyles = (search: boolean = false) => {
  if (search) {
    return {
      background: 'bg-white',
      padding: 'p-1 md:pb-6 pb-5',
      fontSize: ' text-base md:text-xl',
    };
  }

  return {
    background: 'bg-gradient-to-b from-neutrals-liteGrey to-white',
    padding: 'p-3 md:px-8 md:pb-10 md:pt-6',
    fontSize:
      'leading-[30px] md:font-interBold md:text-[30px] lg:text-[34px] text-2xl',
  };
};

export const ProductHeader: React.FC<IProductHeader> = ({
  name,
  description,
  count,
  search,
}) => {
  const { background, padding, fontSize } = getSearchStyles(search);
  return (
    <div
      className={`flex flex-col items-start rounded-xl ${background} ${padding}`}
    >
      <div>
        <h1 className={`font-interSemibold  capitalize ${fontSize}`}>
          {name}
          {count > 0 && (
            <span className="pl-1 pt-0.5 font-interMedium text-sm text-grey-dark opacity-95 md:text-xl">
              ({count})
            </span>
          )}
        </h1>
        {description && (
          <p className="py-2 font-interMedium text-xs leading-4 sm:leading-6 md:pt-4 lg:text-base">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
